/* eslint-disable */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 92px 32px 32px 32px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 16px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px;
`;

export const EmptyContainer: any = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 0 32px 0;
`;

export const EmptyMessage = styled.p`
  font-size: 16px;
  font-family: Inter;
  color: #333;
  line-height: 18px;
`;